/**
 * Значения ViewpointsEnum из archimate3_View.xsd (ArchiMate 3.1).
 * Синхронизировать с {@link ru.example.canvas.util.ArchimateViewpoints} на бэкенде.
 */
export const ARCHIMATE_VIEWPOINT_VALUES = [
	'Organization',
	'Application Platform',
	'Application Structure',
	'Information Structure',
	'Technology',
	'Layered',
	'Physical',
	'Product',
	'Application Usage',
	'Technology Usage',
	'Business Process Cooperation',
	'Application Cooperation',
	'Service Realization',
	'Implementation and Deployment',
	'Goal Realization',
	'Goal Contribution',
	'Principles',
	'Requirements Realization',
	'Motivation',
	'Strategy',
	'Capability Map',
	'Outcome Realization',
	'Resource Map',
	'Value Stream',
	'Project',
	'Migration',
	'Implementation and Migration',
	'Stakeholder',
] as const;

export type ArchimateViewpointValue = (typeof ARCHIMATE_VIEWPOINT_VALUES)[number];

export const ARCHIMATE_VIEWPOINT_MENU_OPTIONS: ReadonlyArray<{
	value: ArchimateViewpointValue;
	label: string;
}> = ARCHIMATE_VIEWPOINT_VALUES.map(value => ({value, label: value}));
